import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServiceCategory } from 'src/app/db/models/categories';
import { ProService } from 'src/app/db/models/pro-services';
import { ServiceHandle } from 'src/app/db/models/service-handle';
import { User } from 'src/app/db/models/user';
import { CategoryService } from 'src/app/services/category.service';
import { HandlesService } from 'src/app/services/handles.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  title = 'Profile Detail';

  pservice: ProService;
  user: User;
  category: ServiceCategory;
  handles: ServiceHandle[];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private service: UserService,
              private hservice: HandlesService,
              private notify: ToastrService)
          { }

  ngOnInit() {
    const stateParams = this.route.snapshot.paramMap.get('id');
    if(stateParams != null){
      const id = stateParams;
      this.getProfileDetail(id);
    }

    // this.getServiceCategory(this.pservice.serviceCategoryId)
  }


  getProfileDetail(id: string) {
    this.service.getUserDetails(id).subscribe({
      next: res => {
        this.user = res;
        this.pservice = res.service;
        this.category = res.category;
        this.handles = res.serviceHandles;
        console.log(this.user)
      },
      error: err => {
        console.error(err);
      }
    })
  }


  confirmDelete(data){
    Swal.fire({
      title: 'Are you sure?',
      text: "Delete action is irreversible",
      icon: 'warning',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.handleDelete(data);
      }
    })
  }

  handleDelete(data: ServiceHandle){
    this.hservice.deleteServiceCategory(data)
    .subscribe( res => {
      res;
      console.log(res)
      this.reload();
    })
  }

  reload(){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/profile/${this.user.id}`])
      })
}

}
